// @flow

import initialStore from '../initialStore';
import type { Action } from '../../actions/auth';

export type FormError = {
  field: string,
  code?: string,
  message?: string
}

export type ApiError = {
  code?: string,
  message: string
}

export type AuthState = {
  email: string,
  password: string,
  authenticated: boolean,
  returning: boolean,
  error: ApiError[],
  loading: boolean,
  formErrors: FormError[],
  tfa_challenge: boolean,
  loaded: boolean,
  tfa_token: ?string,
  message: ?string,
  code: ?string,
  integration_intent: ?string
}

const authReducer = (currentState: AuthState, action: Action) => {
  switch (action.type) {
  case 'RETURNING':
    return Object.assign({}, currentState, {
      loaded: true,
      returning: true,
      loading: false
    });
  case 'AUTH_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false
    });
  case 'LOGIN_MESSAGE':
    return Object.assign({}, currentState, {
      loading: false,
      message: action.message,
      code: action.code
    });
  case 'AUTHENTICATION_FAILURE': {
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error,
      authenticated: false,
      loaded: true
    });
  }
  case 'TFA_CHALLENGE': {
    return Object.assign({}, currentState, {
      tfa_challenge: true,
      loading: false
    });
  }
  case 'SET_TFA_TOKEN': {
    return Object.assign({}, currentState, {
      tfa_token: action.token
    });
  }
  case 'SET_AUTH_FORM':
    return Object.assign({}, currentState, {
      ...action
    });
  case 'AUTHENTICATE':
    return Object.assign({}, currentState, {
      loading: false,
      authenticated: true,
      loaded: true,
      formErrors: [],
      error: [],
      password: ''
    });
  case 'AUTH_FORM_ERRORS':
    return Object.assign({}, currentState, {
      loading: false,
      authenticated: false,
      formErrors: action.errors
    });
  case 'RELOAD_AUTH':
    return Object.assign({}, currentState, {
      loading: true,
      formErrors: [],
      error: []
    });
  case 'LOAD_AUTH':
    return Object.assign({}, currentState, {
      loading: true,
      loaded: false,
      authenticated: false,
      formErrors: [],
      error: []
    });
  case 'MAPLE_AUTH_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      loaded: true,
      integration_intent: 'maple'
    });
  case 'MAPLE_CONNECT':
    return Object.assign({}, currentState, {
      loading: true,
      loaded: false,
      formErrors: [],
      error: []
    });
  case 'MAPLE_CONNECT_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      loaded: true
    });
  case 'MAPLE_CONNECT_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.auth;
  }
};

export default authReducer;

export const fieldError = (state: AuthState, field: string): ?FormError => {
  if (state.formErrors && state.formErrors.length) {
    return state.formErrors.find((e) => e.field === field);
  }
  return undefined;
};

export const genericFormError = (state: AuthState): ?FormError => {
  if (state.formErrors && state.formErrors.length) {
    return state.formErrors.find((e) => !e.field);
  }
  return undefined;
};


// WEBPACK FOOTER //
// ./src/store/reducers/auth.js